import "../Styles/login.scss";
import Button from "../components/Util/Button";
import Input from "../components/Util/Input";
import logo from "../assets/imgs/logo.png";
import { useRef, useState, useEffect } from "react";
import Loading from "../components/Util/Loading";
import ForgetPassword from "../components/Login/ForgetPassword";
import Confetti from "react-confetti";

import lg1 from "../assets/imgs/lg1.png";
import lg2 from "../assets/imgs/lg2.jpg";
import lg3 from "../assets/imgs/lg3.jpg";
import lg4 from "../assets/imgs/lg4.jpg";
import lg5 from "../assets/imgs/lg5.jpg";

const BACKGROUND_IMAGES = [lg1, lg2, lg3, lg4, lg5];

export default function Login(props) {
  const rfEmail = useRef();
  const rfPassword = useRef();
  const [isErr, setIsErr] = useState("");
  const [loading, setIsLoading] = useState(false);
  const [body, updateBody] = useState({
    Email: null,
    Password: null,
  });
  const ref = useRef();
  const [toggleForgot, setToggleForgot] = useState(false);
  const [bgIndex, setBgIndex] = useState(0);

  // Background image rotation (same as Staff Portal)
  useEffect(() => {
    const intervalId = setInterval(() => {
      setBgIndex((i) => (i + 1) % BACKGROUND_IMAGES.length);
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  const login = () => {
    let d = body;
    d.Email = rfEmail.current.getValue().toLowerCase().trim();
    d.Password = rfPassword.current.getValue();
    updateBody(d);
    setIsErr("");

    if (!validateEmail(body.Email))
      return setIsErr("Please Enter a Valid Email Address!");
    if (!validatePassword(body.Password))
      return setIsErr("Password must be at least 6 characters!");

    if (validateEmail(body.Email) && validatePassword(body.Password)) {
      setIsLoading(true);
      fetch("/api/auth/login", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw Error("Login Failed");
          }
        })
        .then((data) => {
          if (data.success) {
            localStorage.setItem("gdfhgfhtkn", data.token);
            setIsErr(data.success);
            setIsLoading(false);
            window.location.href = "/";
          } else {
            setIsLoading(false);
            setIsErr(data.error);
          }
        })
        .catch((err) => {
          setIsLoading(false);
          setIsErr("Login failed");
        });
    }
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const validatePassword = (password) => {
    return password.length >= 6;
  };

  return (
    <div ref={ref} className="login">
      <Confetti
        gravity={0.1}
        colors={["#2196F3", "#29B6F6"]}
        numberOfPieces={10}
        initialVelocityY={(10, 50)}
      />
      <div className="mob">
        <h1>Kirinyaga</h1>
        <h3>AMIS</h3>
      </div>
      <div
        className="login-background"
        style={{ backgroundImage: `url(${BACKGROUND_IMAGES[bgIndex]})` }}
      />
      <div className="card card--single">
        {toggleForgot && <ForgetPassword setToggleForgot={setToggleForgot} />}
        <div className="login-form">
          <header className="login-form__header">
            <h1 className="login-form__title">County Government of Kirinyaga</h1>
            <h2 className="login-form__subtitle">Kiri-AMIS Farmers Portal</h2>
            <img src={logo} alt="Kiri-AMIS" className="login-form__logo" />
          </header>
          <form
            className="login-form__fields"
            onSubmit={(e) => e.preventDefault()}
          >
            <p className="login-form__err">{isErr}</p>
            <Input
              ref={rfEmail}
              type="text"
              label="Email Address"
              placeholder="Email Address"
            />
            <Input
              ref={rfPassword}
              type="password"
              label="Password"
              placeholder="Password"
            />
            <p className="login-form__forgot">
              Forgot password?{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  setToggleForgot(true);
                }}
              >
                click here
              </a>
            </p>
            <Button handleClick={login} value="Submit" />
          </form>
          <footer className="login-form__footer">
            <span className="login-form__powered">Powered by</span>
            <a href="https://osl.co.ke" className="login-form__link">
              Oakar Services Ltd
            </a>
          </footer>
        </div>
        {loading && <Loading />}
      </div>
    </div>
  );
}
